import React from 'react';
import SidebarContainer from "../components/common/Sidebar/SidebarContainer";

export const WithAppendSidebarHOC = (Component) => {

  const AppendSidebar = (props) => {
    const { objectId, headerSubtitle } = props

       
    return (
      <>
        <SidebarContainer editObject={headerSubtitle} objectId={objectId}/>
        <Component {...props} />
      </>
    )
  }


  return AppendSidebar
}
